<template>
  <div
    @click="fixLocation"
    class="fix-location"
  >
    <img src="../../../../assets/images/icon_dw.png" alt="" />
    <!-- <span>定位</span> -->
  </div>
</template>

<script>
import { buryingPoint } from '@/utils/buryingPoint'
import { mapGetters } from 'vuex'
export default {
  name: 'FocusLocalIcon',
  data(){
    return{
      firstSetMap: true,
    }
  },
  props: {
    userPosition: {
      type: Object,
      default: () => {
        return {
          latitude: 23.137,
          longitude: 113.325,
          valid: true,
        }
      },
    },
    map: {
      type: Object,
      default: () => {
        return {}
      },
    }
  },
  computed: {
    ...mapGetters({
      activityId: 'activityInfo/activityId'
    })
  },
  methods: {
    fixLocation() {
      buryingPoint({ action: 16, sourceTag: 2, activityId: this.activityId, itemType: 2 })
      const distance = 10
      this.userPosition && this.map.setCenter([this.userPosition.longitude, this.userPosition.latitude])
      if (!this.firstSetMap) return
      let marker = new AMap.Marker({
        // icon:"//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png",
        position: [this.userPosition.longitude, this.userPosition.latitude],
        offset: new AMap.Pixel(0, 0),
        icon: new AMap.Icon({
          image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',
          size: new AMap.Size(28, 40), //图标大小
          imageSize: new AMap.Size(28, 40),
        }),
      })
      this.userPosition && marker.setMap(this.map)
      this.firstSetMap = false
    },
  },
}
</script>
<style lang='scss' scoped>
.fix-location {
  width: 1.06rem;
  height: 1.06rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  img {
    width: 1.06rem;
    display: inline-block;
  }
  span {
    font-size: 0.24rem;
    color: #333;
  }
}
</style>
